import {
  FiPlusCircle,
  FiEdit3,
  FiTrash2,
  FiEye,
  FiLogIn,
  FiLogOut,
  FiKey,
  FiShield,
  FiCpu,
  FiAlertTriangle,
  FiActivity,
  FiHome,
  FiUser,
} from "react-icons/fi";

/** Audit kategorisi → ikon + ton (Tailwind paleti; hex yok). Son Hareketler + Son İşlemler ortak. */
export const CATEGORY_STYLE = {
  CREATE: { icon: FiPlusCircle, tone: "bg-emerald-50 text-emerald-600 ring-emerald-100" },
  UPDATE: { icon: FiEdit3, tone: "bg-indigo-50 text-indigo-600 ring-indigo-100" },
  DELETE: { icon: FiTrash2, tone: "bg-red-50 text-red-600 ring-red-100" },
  READ: { icon: FiEye, tone: "bg-gray-50 text-gray-500 ring-gray-100" },
  LOGIN: { icon: FiLogIn, tone: "bg-sky-50 text-sky-600 ring-sky-100" },
  LOGOUT: { icon: FiLogOut, tone: "bg-gray-50 text-gray-500 ring-gray-100" },
  PASSWORD_CHANGE: { icon: FiKey, tone: "bg-amber-50 text-amber-600 ring-amber-100" },
  PERMISSION_CHANGE: { icon: FiShield, tone: "bg-purple-50 text-purple-600 ring-purple-100" },
  DEVICE_STATUS: { icon: FiCpu, tone: "bg-teal-50 text-teal-600 ring-teal-100" },
  DEVICE_OPERATION: { icon: FiCpu, tone: "bg-teal-50 text-teal-600 ring-teal-100" },
  AUTHZ: { icon: FiAlertTriangle, tone: "bg-red-50 text-red-600 ring-red-100" },
  RATE_LIMIT: { icon: FiAlertTriangle, tone: "bg-amber-50 text-amber-600 ring-amber-100" },
  ERROR: { icon: FiAlertTriangle, tone: "bg-red-50 text-red-600 ring-red-100" },
};
export const DEFAULT_STYLE = { icon: FiActivity, tone: "bg-gray-50 text-gray-500 ring-gray-100" };
export const categoryStyle = (category) => CATEGORY_STYLE[category] || DEFAULT_STYLE;

/** Konu türü (#412) → ikon + ton */
export const SUBJECT_STYLE = {
  device: { icon: FiCpu, tone: "bg-teal-50 text-teal-700" },
  firm: { icon: FiHome, tone: "bg-indigo-50 text-indigo-700" },
  user: { icon: FiUser, tone: "bg-sky-50 text-sky-700" },
};

/** Ekranda gösterilecek başlık: sunucunun Türkçe `title`'ı (#412); eski yanıtta açıklama */
export const activityTitle = (item) => item?.title || item?.description || "İşlem";
